import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../utils/styleUtils';


function Container({children, classes}) {

    return (
        <div className={styleUtils.toClasses(classes, 'container')}>
            {children}
        </div>
    );
}


Container.propTypes = {
    children: PropTypes.any,
    classes: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string
    ])
};

Container.defaultProps = {
    classes: null
};


export default Container;
